const order = {
    name: "order",
    path: "/order",
    title: "order",
    description: "Utilities for controlling the order of flex and grid items.",
    value: {
        'order': {
            "order-<number>": "<number>",
            "-order-<number>": "-<number>",
            "order-first": "calc(-infinity)",
            "order-last": "calc(infinity)",
            "order-none": "0",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="flex justify-between ...">
  <div class="order-3 ...">01</div>
  <div class="order-1 ...">02</div>
  <div class="order-2 ...">03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="flex justify-between ...">
  <div class="order-last ...">01</div>
  <div class="...">02</div>
  <div class="order-first ...">03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="-order-1">
  <!-- ... -->
</div>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">order-<var>&lt;number&gt;</var></code>
                 utilities like order-1 and order-3 to render flex and grid items in a different order than they appear in the document:
            </p>

            <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="flex justify-between gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex size-14 order-3 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="flex size-14 order-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex size-14 order-2 items-center justify-center rounded-lg bg-color-pink-500 p-4">03</div>
                </div>
            </div>

            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">shrink-<var>&lt;number&gt;</var></code>
                   to prevent a flex item from shrinking:
            </p>

             <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="flex justify-between gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex size-14 order-last items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="flex size-14 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex size-14 order-first items-center justify-center rounded-lg bg-color-pink-500 p-4">03</div>
                </div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">Using negative values</code>
                   To use a negative order value, prefix the class name with a dash to convert it to a negative value:
            </p>

             <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="flex justify-between gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex size-14 -order-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="flex size-14  justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex size-14 -order-2 items-center justify-center rounded-lg bg-color-pink-500 p-4">03</div>
                </div>
            </div>
            `
        },
    ]
};

export default order;

<div className="sr-only order-3 order-2 order-1 order-first order-last -order-2 -order-1">



</div>